import React from "react";
import SignupForm from "../components/SignupForm";

export default function Signup() {
  return (
    <div className="text-center">
      <SignupForm />
    </div>
  );
}
